import React from "react";
import { Shovel, Sparkles, Car, Hammer, Utensils, ShoppingBag, ArrowRight, Scissors } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const trades = [{
  id: "trades-services",
  title: "Trades & Services",
  icon: Hammer,
  description: "From electricians to painters, get a site that works as hard as you do on the tools.",
  href: "/PackagesPage"
}, {
  id: "cleaning-property",
  title: "Cleaning & Property Services",
  icon: Sparkles,
  description: "Build trust with a clean, professional site for your residential or commercial services.",
  href: "/PackagesPage"
}, {
  id: "landscaping-outdoor",
  title: "Landscaping & Outdoor",
  icon: Shovel,
  description: "Display your garden transformations and maintenance services beautifully.",
  href: "/PackagesPage"
}, {
  id: "automotive-detailing",
  title: "Automotive & Detailing",
  icon: Car,
  description: "Attract car enthusiasts with a sleek gallery of your high-end detailing work.",
  href: "/PackagesPage"
}, {
  id: "hospitality",
  title: "Barbers & Hairdressers",
  icon: Scissors,
  description: "Showcase your work and atmosphere to attract local clientele.\xA0",
  href: "/PackagesPage"
}, {
  id: "retail-local",
  title: "Retail & Local Shops",
  icon: ShoppingBag,
  description: "Connect with your local community and grow your storefront's digital presence.",
  href: "/PackagesPage"
}];
export default function BuiltForYourTrade() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="built-for-your-trade" ref={ref} className={cn("bg-background text-foreground py-20 px-4 md:px-8 relative overflow-hidden", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-700 ease-out")}>
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 font-sans">
            Built for Your Trade
          </h2>
          <p className="text-muted-foreground text-lg">
            Whether you're on the tools or managing a team, we build websites tailored to your specific industry needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {trades.map((trade, i) => <Link key={trade.id} to={trade.href} className="block h-full" data-index={i}>
              <Card className="group h-full border border-primary/50 md:border-border hover:border-primary transition-all duration-300 hover:shadow-[0_0_20px_rgba(61,193,188,0.15)] overflow-hidden relative">
                <CardContent className="p-8 flex flex-col h-full">
                  <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <trade.icon className="w-6 h-6" />
                  </div>
                  
                  <h3 className="text-xl font-bold mb-3 group-hover:text-primary transition-colors duration-300">
                    {trade.title}
                  </h3>
                  
                  <p className="text-muted-foreground mb-8 flex-grow leading-relaxed">
                    {trade.description}
                  </p>

                  <div className="flex items-center text-sm font-semibold text-primary opacity-80 group-hover:opacity-100 transition-opacity">
                    <span className="mr-2">Learn More</span>
                    <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                  
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}